import type { IconProps } from './types';

export const Trash = ({ size, ...props }: IconProps) => (
  <svg
    width={size}
    height={size ? size * 1.1 : size}
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.19 4.52999H14.25V3.05999C14.25 2.23999 13.93 1.46999 13.34 0.88999C12.75 0.30999 11.97 -0.0100098 11.14 -0.0100098H8.84C8.01 -0.0100098 7.23 0.30999 6.64 0.88999C6.05 1.46999 5.73 2.23999 5.73 3.05999V4.52999H0.81C0.59 4.52999 0.39 4.60999 0.24 4.75999C0.09 4.90999 0 5.10999 0 5.31999C0 5.52999 0.08 5.72999 0.24 5.87999C0.39 6.02999 0.6 6.10999 0.81 6.10999H2.3V18.92C2.3 19.74 2.62 20.51 3.21 21.09C3.8 21.67 4.58 21.99 5.41 21.99H14.6C15.43 21.99 16.21 21.67 16.8 21.09C17.39 20.51 17.71 19.74 17.71 18.92V6.12999H19.2C19.42 6.12999 19.62 6.04999 19.77 5.89999C19.92 5.74999 20.01 5.54999 20.01 5.33999C20.01 5.12999 19.92 4.91999 19.77 4.77999C19.62 4.62999 19.41 4.54999 19.2 4.54999L19.19 4.52999ZM7.36 3.05999C7.36 2.66999 7.51 2.29999 7.8 2.01999C8.08 1.74999 8.46 1.58999 8.85 1.58999H11.15C11.54 1.58999 11.93 1.74999 12.2 2.01999C12.48 2.29999 12.64 2.66999 12.64 3.05999V4.52999H7.36V3.05999ZM16.08 18.93C16.08 19.32 15.93 19.69 15.64 19.97C15.36 20.25 14.98 20.4 14.59 20.4H5.4C5.01 20.4 4.62 20.24 4.35 19.97C4.07 19.69 3.91 19.32 3.91 18.93V6.12999H16.08V18.94V18.93Z"
      fill="currentColor"
    />
  </svg>
);
